import styled from 'styled-components';
import { colors } from '../../styles/theme';

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${colors.neutral.gray50};

  // Respect users who prefer reduced motion, scoped to this page subtree only.
  @media (prefers-reduced-motion: reduce) {
    & * {
      animation: none !important;
      transition: none !important;
    }
  }
`;
